"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const parse = (query) => {
    query = query.replace(/^\?/, '');
    if (query === '') {
        return {};
    }
    return query.split('&').reduce((params, hash) => {
        const [key, val] = hash.split('=');
        const value = decodeURIComponent(val || '');
        if (params[key]) {
            if (Array.isArray(params[key])) {
                params[key].push(value);
            }
            else {
                params[key] = [params[key], value];
            }
        }
        else {
            params[key] = value;
        }
        return params;
    }, {});
};
exports.parse = parse;
//# sourceMappingURL=querystring.helper.js.map